module.exports = __webpack_public_path__ + "media/images/publish-empty-d1945507d19a11f2f491636cfd9b7ed8.png";